import bunyan from 'bunyan'
import canUseDom from '@argos/utils/esnext/canUseDom'

const createLoggerInstance = (name) => {
  return bunyan.createLogger({ name })
}

export default (type, name, responseData = '', msg = '') =>
  !canUseDom() && createLoggerInstance(name)[type](responseData, msg)
